module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "main-container clearfix"
  }, [_c('floating'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "recommend__identify"
  }, [_c('h3', [_c('img', {
    attrs: {
      "src": _vm.picPc
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "title__en"
  }, [_vm._v("Professional real estate finance")]), _vm._v(" "), _c('h4', {
    staticClass: "title__ch"
  }, [_vm._v("专业的房产金融服务")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.productName))]), _vm._v(" "), _c('p', {
    staticClass: "detail-summary"
  }, [_vm._v(_vm._s(_vm.summary))]), _vm._v(" "), _c('p', {
    staticClass: "details"
  }, [_vm._v("\n            " + _vm._s(_vm.explain) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "detailBtn-wrap"
  }, [_c('button', {
    staticClass: "detailBtn",
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("立即申请借款")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "paragraph-wrapper"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-title"
  }), _vm._v(" "), _vm._l((_vm.apply), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item.title) + ": " + _vm._s(item.content))])
  })], 2)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "paragraph-wrapper"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-title"
  }), _vm._v(" "), _vm._l((_vm.application), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item.title) + ": " + _vm._s(item.content))])
  })], 2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "paragraph-wrapper"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-title"
  }), _vm._v(" "), _vm._l((_vm.material), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item.content))])
  })], 2)])]), _vm._v(" "), _c('modal', {
    staticClass: "borrow-dialog",
    attrs: {
      "show": _vm.show
    },
    on: {
      "dismiss": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrap"
  }, [_c('div', {
    staticClass: "page-caption"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("申请借款")])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal form-custom",
    attrs: {
      "novalidate": "novalidate"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitHandler($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-xs-4"
  }, [_vm._v("借款金额：")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.money),
      expression: "money",
      modifiers: {
        "number": true
      }
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.money = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("元")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-xs-4"
  }, [_vm._v("借款期限：")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.duration),
      expression: "duration",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.duration = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("天")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('p', {
    staticClass: "err-wrap"
  }, [_vm._v(_vm._s(_vm.errmsg)), _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("确  定")])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__title"
  }, [_c('h2', {
    staticClass: "large__title"
  }, [_vm._v("产品信息")]), _vm._v(" "), _c('h4', {
    staticClass: "small__title square"
  }, [_vm._v("PRODUCT INFO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-side text-center"
  }, [_c('h1', [_vm._v("申请条件")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-side text-center"
  }, [_c('h1', [_vm._v("适用人群")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-side text-center"
  }, [_c('h1', [_vm._v("所需材料")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2b4ebd38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/borrow/detail.vue
// module id = 588
// module chunks = 1